module.exports = __webpack_public_path__ + "img/FR11206.2d45e5e9.svg";